import { ifAuthenticated } from '@/router/before'

export const importRouteNames = {
  ImportProcessRoute: 'ImportProcessRoute'
}
const rn = importRouteNames

export const importRouteURLs = {
  [rn.ImportProcessRoute]: '/import/publications'
}

export const importPages = [
  {
    path: importRouteURLs[rn.ImportProcessRoute],
    name: rn.ImportProcessRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'file-import'],
        isDisplay: true
      },
      navbar: {
        group: 'Импорт',
        displayName: 'Импорт публикаций'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ImportProcessRoute" */ '@/views/import/ImportProcessRoute.vue'
      )
  }
]
